<button mat-icon-button [matMenuTriggerFor]="projectMenu">
  <mat-icon aria-label="Project Menu">more_vert</mat-icon>
</button>
<mat-menu #projectMenu="matMenu" xPosition="before">
  <div class="header-account-menu">
    @if (isChild) {
      <div class="menu-info secondary-text" i18n>Parent ID: {{ project.parentId }}</div>
      <mat-divider />
    }
    <a mat-menu-item (click)="copyProject()">
      <mat-icon>content_copy</mat-icon> <ng-container i18n>Copy</ng-container>
    </a>
    @if (canEdit) {
      <a mat-menu-item (click)="editProject()">
        <mat-icon>edit</mat-icon> <ng-container i18n>Edit</ng-container>
      </a>
    }
    @if (canShare) {
      <a mat-menu-item (click)="shareProject()">
        <mat-icon>share</mat-icon> <ng-container i18n>Share</ng-container>
      </a>
    }
    @if (isMyUnit) {
      <a mat-menu-item href="{{ publishUnitUrl }}">
        <mat-icon>public</mat-icon> <ng-container i18n>Publish</ng-container>
      </a>
    }
    @if (!project.metadata.publicUnitType) {
      @if (archived) {
        <a mat-menu-item (click)="archive(false)">
          <mat-icon>unarchive</mat-icon>
          <span i18n>Restore</span>
        </a>
      } @else {
        <a mat-menu-item (click)="archive(true)">
          <mat-icon>archive</mat-icon>
          <span i18n>Archive</span>
        </a>
      }
    }
  </div>
</mat-menu>
